export default "__VITE_ASSET__CqWHolY5__"